module.exports = __webpack_public_path__ + "static/media/Platformicon03@3x.779ab165.png";